const REQUEST_DB_NAME = 'REQUESTS_RETRY';
const REQUEST_STORE_NAME = 'requests';
const REQUEST_VERSION = 1;

export function openRequestDB() {
  if (!window.indexedDB || !indexedDB) return null;

  return new Promise<IDBDatabase | null>((resolve, reject) => {
    const request = indexedDB.open(REQUEST_DB_NAME, REQUEST_VERSION);

    request.onupgradeneeded = (event: EventCustom<{ result: IDBDatabase }>) => {
      const db = event.target?.result;

      if (!db?.objectStoreNames.contains(REQUEST_STORE_NAME)) {
        db?.createObjectStore(REQUEST_STORE_NAME, {
          keyPath: 'id',
          autoIncrement: true,
        });
      }
    };

    request.onsuccess = (event: EventCustom<{ result: IDBDatabase }>) =>
      resolve(event.target?.result || null);

    request.onerror = (event) => reject(event.target);
  });
}

export async function addRequestToQueue(data: string) {
  return new Promise(async (resolve, reject) => {
    const db = await openRequestDB();

    if (!db) return;

    const transaction = db.transaction(REQUEST_STORE_NAME, 'readwrite');

    transaction
      .objectStore(REQUEST_STORE_NAME)
      .add({ data, timestamp: Date.now() });

    transaction.oncomplete = (event) => {
      resolve(event.target);
    };

    transaction.onerror = (event) => {
      reject(event.target);
    };
  });
}

export async function getAllRequestQueue(): Promise<
  { data: string; id: number }[]
> {
  const db = await openRequestDB();

  if (!db) return [];

  return new Promise((resolve) => {
    const transaction = db.transaction(REQUEST_STORE_NAME, 'readonly');
    const store = transaction.objectStore(REQUEST_STORE_NAME);
    const request = store.getAll();
    request.onsuccess = () => resolve(request.result);
  });
}

export async function deleteRequestFromQueue(id: number) {
  const db = await openRequestDB();

  if (!db) return;

  const tx = db.transaction(REQUEST_STORE_NAME, 'readwrite');
  tx.objectStore(REQUEST_STORE_NAME).delete(id);
}
